<template>

</template>

<script>

    export default {

        data() {
            return {
                progress: 30,
            };
        },

        methods: {
            next: function(step) {
                this.$root.$emit('nextStep', step);
            }
        }

    }

</script>